export default __webpack_public_path__ + "img/forgot-password-icon.f6cab984.svg";